<template>
    <div>
       <div id="page">
            <Header></Header>
        <div class="swipe01">
            <div class="swipe01-head swipe01-tr">
                <div class="swipe01-td">序号</div>
                <div class="swipe01-td">楼盘名称</div>
                <div class="swipe01-td">楼盘类型</div>
                <div class="swipe01-td">当前状态</div>
            </div>
            <div class="swipe01-body">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <van-swipe-cell class="wrap" :right-width="rightWidth" v-for="(item, index) in list">
                        <div class="swipe01-tr">
                            <div class="swipe01-td">{{ index+1 }}</div>
                            <div class="swipe01-td">{{ item.building_name }}</div>
                            <div class="swipe01-td">{{ item.buildings_type }}</div>
                            <div class="swipe01-td">{{ item.building_status_nm }}</div>
                        </div>
                        <div class="swipe01-tool" slot="right">
                            <div class="btn s1" v-if="item.building_status=='wait'" @click="Toast('您发布的楼盘正在审核中，请稍作等待！')">查看</div>
                            <div class="btn s1" v-if="item.building_status=='pass'&&item.show_status=='yes'"><router-link :to="{path: 'property', query: {id: item.building_id }}">查看</router-link></div>
                            <div class="btn s1" v-if="item.building_status=='reject'" @click="delBuilding(item.building_id)">删除</div>
                            <div class="btn s1" v-if="item.building_status=='pass'&&item.show_status=='yes'" @click="cancelBuilding(item.building_id)">放弃</div>
                        </div>
                    </van-swipe-cell>
                </van-list>
            </div>
        </div>
       </div>

        <Footer></Footer>
    </div>
</template>

<script scoped>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { SwipeCell, Popup, Dialog, Toast, List } from 'vant'

    export default {
        name: "UserBuildingList",
        data: function () {
            return {
                rightWidth: document.body.clientWidth/750*200,
                showPop: false,
                loading: false,
                finished: false,
                list: [],
                page: 1
            }
        },
        components: {
            Header, Footer,
            [SwipeCell.name]: SwipeCell,
            [Dialog.name]: Dialog,
            [Popup.name]: Popup,
            [Toast.name]: Toast,
            [List.name]: List
        },
        mounted(){
            this.getList();
        },
        methods: {
            getList () {
                const _this = this;
                _this.api.getUserBuildingList({
                    page: _this.page,
                    pageSize: 20
                }).then(function(response){
                    _this.loading = false;
                    _this.page++;
                    if (response.building_list.length < 20) {
                        _this.finished = true;
                    }
                    for (let i in response.building_list) {
                        response.building_list[i].re_create_time = _this.formatTime(response.building_list[i].create_time, '{y}.{m}.{d}')
                    }
                    if (_this.list.length == 0) {
                        _this.list = response.building_list;
                    } else if (_this.list[_this.list.length - 1].building_id != response.building_list[response.building_list.length - 1].building_id) {
                        _this.list = _this.list.concat(response.building_list);
                    }
                })
            },
            cancelBuilding(id){
                const _this = this;
                let params = new FormData();
                params.append('building_id', id);
                _this.api.cancelUserBuilding(params).then(function(response){
                    Toast(response.msg);
                    _this.page = 1;
                    _this.list = [];
                    _this.getList();
                })
            },
            delBuilding (id) {
                const _this = this;
                let params = new FormData();
                params.append('building_id', id);
                _this.api.delUserBuilding(params).then(function(response){
                    Toast(response.msg);
                    _this.page = 1;
                    _this.list = [];
                    _this.getList();
                })
            },
            onLoad(){
                setTimeout(()=>{
                    this.getList();
                }, 500)
            }
        }
    }
</script>

<style scoped>
    /deep/ .swipe01-tool {width: 2rem;}
</style>
